import React, { useState, useEffect } from "react";
import {
  Typography,
  FormControl,
  TextField,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  Input,
  InputAdornment,
  CircularProgress,
} from "@material-ui/core";
import { anonAuthServiceClient as axios } from "../../AxiosClient";
import { Check, Clear } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

let checkDebounce;
function LicenceInput(props) {
  const { t } = useTranslation();
  const [licenceValid, setLicenceValid] = useState(null);

  useEffect(
    () => {
      if (props.licenceKey) {
        debounceCheck();
      }
    },
    [props.licenceKey]
  );

  const debounceCheck = () => {
    if (checkDebounce) {
      window.clearTimeout(checkDebounce);
    }
    checkDebounce = window.setTimeout(() => {
      axios
        .post(`/licence/valid`, { key: props.licenceKey })
        .then(() => {
          setLicenceValid(true);
          props.setLicenceValid(true);
        })
        .catch(() => {
          setLicenceValid(false);
          props.setLicenceValid(false);
        });
      checkDebounce = null;
    }, 500);
  };
  return (
    <FormControl
      style={{ width: "100%" }}
      error={props.licenceKey && licenceValid === false}
      className={props.className}
    >
      <InputLabel htmlFor="outlined-adornment-amount">
        {t("licence_key")}
      </InputLabel>
      <Input
        id="outlined-adornment-amount"
        multiline
        rows={3}
        value={props.licenceKey}
        error={props.licenceKey && licenceValid === false}
        onChange={(e) => {
          props.setKey(e.target.value);
          setLicenceValid(null);
          props.setLicenceValid(false);
        }}
        endAdornment={
          <>
            {props.licenceKey && (
              <InputAdornment position="end">
                {licenceValid === null ? (
                  <CircularProgress size={24} />
                ) : (
                  <>{licenceValid ? <Check /> : <Clear />}</>
                )}
              </InputAdornment>
            )}
          </>
        }
        labelWidth={60}
      />
      <FormHelperText
        error={props.licenceKey && licenceValid === false}
        id="outlined-weight-helper-text"
      >
        {props.licenceKey && licenceValid !== null ? (
          <>
            {licenceValid ? "This licence is valid" : "This licence is invalid"}
          </>
        ) : (
          "Enter your licence key"
        )}
      </FormHelperText>
    </FormControl>
  );
}

export default LicenceInput;
